import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_TOS_LEGAL_NOTICE_BANNER_COPY = defineFcm('tos_legal_notice_banner_copy')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				preEffectiveText: { type: 'string' },
				postEffectiveText: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'Terms of Service legal/policy banner',
		description: `Copy for the ToS banner

			- preEffectiveText: text to be displayed before the ToS effective date
			- postEffectiveText: text to be displayed after the ToS effective date

			Replacements:
			- tosEffectiveDateShort: formatted date based on the effective date from tos_legal_notice_banner as a short date (e.g. 10/20/2022)
			- tosEffectiveDateMedium: formatted date based on the effective date from tos_legal_notice_banner as a medium date (e.g. 20th Oct 2022)
			- tosEffectiveTime: formatted time based on the effective date from tos_legal_notice_banner (e.g. 1:14 PM)

			Related to tos_legal_notice_banner FCM`,
		import: false,
		template: {
			preEffectiveText: 'ToS are changing on %{tosEffectiveDateShort} at %{tosEffectiveTime}',
			postEffectiveText:
				'ToS were changed on %{tosEffectiveDateShort} at %{tosEffectiveTime} (see <a href="/tos">new ToS</a>)',
		},
	});
